import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import HeroFeature from "./components/HeroFeature";
import TodayBrief from "./components/TodayBrief";
import HeatRanking from "./components/HeatRanking";
import TopicWall from "./components/TopicWall";
import LiveTimeline from "./components/LiveTimeline";
import EditorPicks from "./components/EditorPicks";
import SubscribeBand from "./components/SubscribeBand";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 font-body text-foreground-950">
      <SiteHeader />
      <main>
        <HeroFeature />
        <TodayBrief />
        <HeatRanking />
        <TopicWall />
        <LiveTimeline />
        <EditorPicks />
        <SubscribeBand />
      </main>
      <SiteFooter />
    </div>
  );
}